import { useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2, Truck } from "lucide-react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart, FREE_SHIPPING_FROM } from "@/context/CartContext";
import { euro, imgSrc } from "@/lib/api";

export const CartDrawer = () => {
  const { items, open, setOpen, setQty, remove, subtotal } = useCart();
  const navigate = useNavigate();
  const left = Math.max(FREE_SHIPPING_FROM - subtotal, 0);
  const pct = Math.min((subtotal / FREE_SHIPPING_FROM) * 100, 100);

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="w-full sm:max-w-md flex flex-col p-0" data-testid="cart-drawer">
        <SheetHeader className="p-6 border-b">
          <SheetTitle className="font-heading text-2xl font-black uppercase tracking-tight">Tu carrito</SheetTitle>
        </SheetHeader>
        {items.length === 0 ? (
          <div className="flex-1 grid place-items-center text-slate-500 text-sm" data-testid="cart-empty">Tu carrito está vacío</div>
        ) : (
          <>
            <div className="px-6 py-4 bg-slate-50 border-b" data-testid="free-shipping-progress">
              <p className="text-xs flex items-center gap-2 font-medium">
                <Truck className="w-4 h-4 text-brand" />
                {left > 0 ? <>Te faltan <b>{euro(left)}</b> para el envío gratis</> : <>¡Tienes envío gratis!</>}
              </p>
              <div className="mt-2 h-1.5 bg-slate-200 rounded-full overflow-hidden">
                <div className="h-full bg-brand transition-[width] duration-500" style={{ width: `${pct}%` }} />
              </div>
            </div>
            <ul className="flex-1 overflow-y-auto divide-y">
              {items.map((i) => (
                <li key={i.key} className="p-6 flex gap-4" data-testid={`cart-item-${i.key}`}>
                  <img src={imgSrc(i.image, 200)} alt={i.name} className="w-20 h-24 object-cover bg-slate-100" />
                  <div className="flex-1 min-w-0">
                    <p className="font-semibold text-sm truncate">{i.name}</p>
                    <p className="text-xs text-slate-500 mt-0.5">Talla {i.size}{i.color && ` · ${i.color}`}</p>
                    <div className="mt-3 flex items-center gap-2">
                      <button className="qty-btn" onClick={() => setQty(i.key, i.quantity - 1)} data-testid={`cart-dec-${i.key}`}><Minus className="w-3 h-3" /></button>
                      <span className="w-6 text-center text-sm font-semibold" data-testid={`cart-qty-${i.key}`}>{i.quantity}</span>
                      <button className="qty-btn" onClick={() => setQty(i.key, i.quantity + 1)} data-testid={`cart-inc-${i.key}`}><Plus className="w-3 h-3" /></button>
                      <button className="ml-auto text-slate-400 hover:text-brand" onClick={() => remove(i.key)} data-testid={`cart-remove-${i.key}`}><Trash2 className="w-4 h-4" /></button>
                    </div>
                  </div>
                  <p className="text-sm font-bold">{euro(i.price * i.quantity)}</p>
                </li>
              ))}
            </ul>
            <div className="p-6 border-t space-y-4">
              <div className="flex justify-between font-bold"><span>Subtotal</span><span data-testid="cart-subtotal">{euro(subtotal)}</span></div>
              <button className="btn-primary w-full" onClick={() => { setOpen(false); navigate("/checkout"); }} data-testid="cart-checkout-button">
                Finalizar compra
              </button>
            </div>
          </>
        )}
      </SheetContent>
    </Sheet>
  );
};
